/**
 * Validates the runtime configuration injected by the independent static server.
 */

import { z } from "zod";

const backofficeEnvironmentSchema = z
  .object({
    apiBaseUrl: z.url(),
    apiTimeoutMs: z.number().int().positive(),
    portalBaseUrl: z.url(),
  })
  .strict();

declare global {
  interface Window {
    readonly __BACKOFFICE_CONFIG__?: unknown;
  }
}

export type BackofficeEnvironment = z.infer<typeof backofficeEnvironmentSchema>;

/**
 * Fails visibly before using an absent or malformed operational endpoint.
 */
export function LoadBackofficeEnvironment(): BackofficeEnvironment {
  return backofficeEnvironmentSchema.parse(window.__BACKOFFICE_CONFIG__);
}
